<template>
    <div>
        <v-dialog persistent v-model="modal" max-width="600" class="pa-4">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi mdi-key-variant"
                    outlined
                    small
                >
                    Trocar chave Pix
                    <v-icon size="small" class="ml-2">
                        mdi-key-variant
                    </v-icon>
                </v-btn>
            </template>
            <v-card class="overflow-hidden">
                <v-card-title>Trocar chave pix</v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                    <v-row class="justify-space-between" align="center">
                        <v-col cols="4">
                            <v-radio-group class="ma-0 pa-0" v-model="pixKeyType" label="Tipo da Chave Pix">
                                <v-radio label="CNPJ" value="cnpj"></v-radio>
                                <v-radio label="CPF" value="cpf"></v-radio>
                                <v-radio label="Celular" value="cellphone"></v-radio>
                                <v-radio label="E-mail" value="email"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="pixKey"
                                :disabled="pixKeyType === ''"
                                :rules="pixKeyRules"
                                v-mask="`${pixKeyMask}`"
                                label="Chave Pix"
                                outlined
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions >
                    <v-row class="pa-4" justify="end">
                        <v-btn plain color="darken-1" @click="closeDialog()">Voltar</v-btn>
                        <v-btn color="success" @click="changePixKey()" :loading="loading">Trocar chave</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <response-dialog
            :model="responseDialog"
            :message="responseMessage"
            :type="responseType"
            @close="closeAndReload()"
        />
    </div>
</template>

<script>
import ResponseDialog from "../../../components/Dialog/ResponseDialog.vue";
import { isValidCnpj } from "../../../helpers/ValidationRuleHelper";

export default {
    name: "ChangePixKey",
    components: {ResponseDialog},
    props: ['booking'],
    data: () => ({
        pixKeyType: '',
        pixKey: '',
        modal: false,
        loading: false,
        valid: false,
        responseDialog: false,
        responseMessage: '',
        responseType: '',
    }),
    computed: {
        pixKeyRules() {
            if (this.pixKeyType === 'cpf') {
                return [
                    v => !!v || 'A chave pix é obrigatória',
                    v => !!v.match('^[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}\\-[0-9]{2}$') || 'Informe um CPF válido'
                ];
            }
            if (this.pixKeyType === 'cnpj') {
                return [
                    v => !!v || 'A chave pix é obrigatória',
                    v => isValidCnpj(v) || 'Informe um CNPJ válido'
                ];
            }
            if (this.pixKeyType === 'email') {
                return [
                    v => !!v || 'A chave pix é obrigatória',
                    v => !!v.match('^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$') || 'Informe um e-mail válido'
                ];
            }
            if (this.pixKeyType === 'cellphone') {
                return [
                    v => !!v || 'A chave pix é obrigatória',
                    v => !v || !!v.match('^\\([0-9]{2}\\)\\ [0-9]{5}\\-[0-9]{4}$') || 'Informe um celular válido'
                ];
            }
            return [];
        },
        pixKeyMask() {
            if (this.pixKeyType === 'cnpj') {
                return 'NN.NNN.NNN/NNNN-##';
            }
            if (this.pixKeyType === 'cpf') {
                return '###.###.###-##';
            }
            if (this.pixKeyType === 'cellphone') {
                return '(##) #####-####';
            }
            return '';
        },
    },
    watch: {
        pixKey(val) {
            if (this.pixKeyType === 'cnpj' && val && val !== val.toUpperCase()) {
                this.pixKey = val.toUpperCase();
            }
        },
    },
    methods: {
        closeDialog() {
            this.modal = false;
        },
        closeAndReload() {
            this.responseDialog = false;
            this.modal = false;
            this.responseMessage = '';
            this.responseType = '';
            this.pixKeyType = '';
            this.pixKey = '';
            window.location.reload();
        },
        changePixKey() {
            this.$refs.form.validate();
            if (!this.valid) return;

            this.loading = true;
            const params = {
                pixKey: this.pixKey,
                pixKeyType: this.pixKeyType,
            };
            axios.put(`/api/payment/change-pix-key/` + this.booking.id, params).then((res) => {
                this.responseMessage = res.data.message;
                this.responseType = 'success';
                this.responseDialog = true;
            }).catch((err) => {
                this.responseMessage = err.response.data.message;
                this.responseType = 'error';
                this.responseDialog = true;
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style scoped>
.dialog-card {
    max-width: 500px;
}
</style>
